{
  "name": "angular-client-base",
  "version": "3.3.3+260",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start-with-browser": "ng serve -o --port 4602",
    "startdebug": "ng serve",
    "startlocal": "ng serve -c testlocal",
    "build": "ng build",
    "buildCheck": "ng build -c buildCheck",
    "buildprod": "ng build -c production",
    "buildtest-prod": "ng build -c test-prod",
    "buildtest": "ng build -c test",
    "builddev": "ng build -c dev",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.0",
    "@angular/cdk": "^21.0.5",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.6",
    "@angular/localize": "^21.0.6",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-browser-dynamic": "^21.0.6",
    "@angular/router": "^21.0.6",
    "@azure/msal-angular": "^3.1.0",
    "@azure/msal-browser": "^3.30.0",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@ng-idle/core": "^16.0.0",
    "@ng-idle/keepalive": "^16.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@syncfusion/ej2-angular-base": "32.1.19",
    "@syncfusion/ej2-angular-buttons": "32.1.19",
    "@syncfusion/ej2-angular-calendars": "32.1.19",
    "@syncfusion/ej2-angular-dropdowns": "32.1.19",
    "@syncfusion/ej2-angular-filemanager": "32.1.19",
    "@syncfusion/ej2-angular-grids": "32.1.19",
    "@syncfusion/ej2-angular-image-editor": "32.1.19",
    "@syncfusion/ej2-angular-inputs": "32.1.19",
    "@syncfusion/ej2-angular-navigations": "32.1.19",
    "@syncfusion/ej2-angular-notifications": "32.1.19",
    "@syncfusion/ej2-angular-popups": "32.1.19",
    "@syncfusion/ej2-angular-querybuilder": "32.1.19",
    "@syncfusion/ej2-angular-richtexteditor": "32.1.19",
    "@syncfusion/ej2-angular-splitbuttons": "32.1.19",
    "@syncfusion/ej2-locale": "32.1.19",
    "angularx-qrcode": "^21.0.4",
    "bootstrap": "^5.3.8",
    "cldr-data": "36.0.4",
    "core-js": "^3.47.0",
    "luxon": "^3.7.2",
    "rxjs": "^7.8.2",
    "sass": "^1.97.1",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.4",
    "@angular-eslint/builder": "^21.0.0",
    "@angular-eslint/eslint-plugin": "^21.0.0",
    "@angular-eslint/eslint-plugin-template": "^21.0.0",
    "@angular-eslint/schematics": "^21.0.0",
    "@angular-eslint/template-parser": "^21.0.0",
    "@angular/cli": "^21.0.4",
    "@angular/compiler-cli": "^21.0.0",
    "@angular/language-service": "^21.0.6",
    "@types/jasmine": "^5.1.13",
    "@types/jasminewd2": "^2.0.13",
    "@types/luxon": "^3.7.1",
    "@types/node": "^20.19.27",
    "@typescript-eslint/eslint-plugin": "^8.50.0",
    "@typescript-eslint/parser": "^8.50.0",
    "eslint": "^9.39.2",
    "jasmine-core": "^5.13.0",
    "jasmine-spec-reporter": "^7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ts-node": "^10.9.2",
    "typescript": "~5.9.3"
  }
}
